var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"support-ico",class:_vm.iconCls})
}
var staticRenderFns = []

export { render, staticRenderFns }